class Scroll {
  static items = [];

  static width = null;

  static state = 0;

  static getWidth() {
    if (Scroll.width !== null) return Scroll.width;
    const outer = document.createElement('div');
    outer.className = 'el-scrollbar__wrap';
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.position = 'absolute';
    outer.style.top = '-9999px';
    document.body.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = 'scroll';

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    Scroll.width = widthNoScroll - widthWithScroll;
    return Scroll.width;
  }

  static enable() {
    Scroll.init();
    if (Scroll.items.find(i => !i.enable)) {
      return;
    }
    document.body.classList.remove('scroll-disabled');
  }

  static disable() {
    Scroll.init();
    document.body.classList.add('scroll-disabled');
  }

  static init() {
    if (Scroll.state) {
      return;
    }
    Scroll.state = 1;
    const el = document.createElement('style');
    const width = Scroll.getWidth();
    el.innerHTML = `.scroll-disabled{overflow: hidden;padding-right: ${width}px;}`;
    document.head.append(el);
  }

  constructor() {
    this.$eneble = true;
    Scroll.items.push(this);
  }

  get enable() {
    return this.$eneble;
  }

  set enable(value) {
    this.$eneble = value;
    if (value) {
      Scroll.enable();
    } else {
      Scroll.disable();
    }
  }

  destroy() {
    Scroll.items = Scroll.items.filter(i => i !== this);
    Scroll.enable();
  }
}

export default {
  Scroll,
  enable: Scroll.enable,
  disable: Scroll.disable,
};
